import React from 'react';
import './JogadorToggle.css';

const JogadorToggle = ({ jogadorKey, nome, obtida, onToggle }) => {
  return (
    <div className={`jogador-row ${obtida ? 'obtida' : 'faltando'}`}>
      <span className="jogador-nome">{nome}</span>
      <button
        className="jogador-btn"
        onClick={() => onToggle(jogadorKey)}
        aria-pressed={obtida}
      >
        {obtida ? '✓ Tenho' : '✕ Não Tenho'}
      </button>
    </div>
  );
};

export default JogadorToggle;
